export default __webpack_public_path__ + "static/media/headset.a5c23895.jpg";